import { getCheck24Namespace } from 'utility/Provide/Namespace/getCheck24Namespace';
import { BaseUrlProvider } from 'utility/Request/Api/types';

export const defaultBaseUrlProvider: BaseUrlProvider = () => {
    const ns = getCheck24Namespace();

    return Promise.resolve(
        ns?.components?.backendInformationFunc?.getUrlPrefix?.() ?? ''
    );
};

export const baseLocationProvider: BaseUrlProvider = async () => {
    const ns = getCheck24Namespace();
    const urlPrefix = await Promise.resolve(
        ns?.components?.backendInformationFunc?.getUrlPrefix?.() ?? ''
    );
    return urlPrefix != '' ? urlPrefix : window.location.origin;
};
